// Função para ordenar as imagens
export const sortImages = (images) => {
  const ordemDesejada = {
    'LOCAL': 1,
    'EPI': 2,
    'DESLIGAR': 3,
    'BLOQUEAR': 4,
    'TESTAR': 5,
    'ATERRAR': 6,
    'PROTEGER': 7,
    'SINALIZAR': 8
  };

  // Primeiro, agrupar imagens por tipo
  const imagensPorTipo = images.reduce((acc, img) => {
    if (!acc[img.tipoImagem]) {
      acc[img.tipoImagem] = [];
    }
    acc[img.tipoImagem].push(img);
    return acc;
  }, {});

  // Reindexar as imagens por tipo
  const imagesReindex = Object.entries(imagensPorTipo).flatMap(([tipo, imgs]) => {
    // Ordenar as imagens do mesmo tipo pelo índice original
    const sortedImg = [...imgs].sort((a, b) => a.imageIndex - b.imageIndex);
    
    // Reindexar começando do 1
    return sortedImg.map((img, idx) => ({
      ...img,
      imageIndex: idx + 1
    }));
  });

  // Ordenar por tipo e novo índice
  const sortedImages = imagesReindex.sort((a, b) => {
    const sortA = ordemDesejada[a.tipoImagem] || 999;
    const sortB = ordemDesejada[b.tipoImagem] || 999;
    
    if (sortA === sortB) {
      return a.imageIndex - b.imageIndex;
    }
    
    return sortA - sortB;
  });

  return sortedImages;
};
